import { render, staticRenderFns } from "./jfEvent.vue?vue&type=template&id=391901c8&scoped=true&"
import script from "./jfEvent.vue?vue&type=script&lang=js&"
export * from "./jfEvent.vue?vue&type=script&lang=js&"
import style0 from "./jfEvent.vue?vue&type=style&index=0&id=391901c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391901c8",
  null
  
)

export default component.exports